import React, { useState, useEffect } from 'react';
import { startRegistration } from '@simplewebauthn/browser';
import { api } from '../utils/api';

export default function RegisterPage() {
  const [employees, setEmployees] = useState([]);
  const [employeeId, setEmployeeId] = useState('');
  const [status, setStatus]   = useState('idle');
  const [message, setMessage] = useState('');

  useEffect(() => { api.getEmployees().then(setEmployees).catch(() => {}); }, []);

  async function handleRegister() {
    if (!employeeId) { setMessage('Please select an employee.'); setStatus('error'); return; }
    try {
      setStatus('registering'); setMessage('');
      const options    = await api.registerOptions(employeeId);
      const credential = await startRegistration(options);
      await api.registerVerify(credential);
      setStatus('success');
      setMessage('Biometric registered! This employee can now check in on this device.');
    } catch (e) {
      setMessage(e.message || 'Registration failed. Please try again.');
      setStatus('error');
    }
  }

  return (
    <div style={{ display:'flex', justifyContent:'center', padding:'2rem 1rem' }}>
      <div className="card" style={{ maxWidth: 460, width: '100%' }}>
        <h1 style={{ fontWeight:600, fontSize:18, marginBottom:4 }}>Register biometric</h1>
        <p style={{ color:'var(--gray-500)', fontSize:13, marginBottom:'1.5rem' }}>
          One-time setup per device. Enrolls an employee's fingerprint or Face ID for daily check-in.
        </p>

        {status === 'success' ? (
          <>
            <div className="alert alert-success" style={{ marginBottom:'1rem' }}>{message}</div>
            <button className="btn btn-secondary btn-block" onClick={() => { setStatus('idle'); setEmployeeId(''); }}>
              Register another employee
            </button>
          </>
        ) : (
          <>
            <label style={S.label}>Employee</label>
            <select value={employeeId} onChange={e => setEmployeeId(e.target.value)} style={{ marginBottom:'1.25rem' }}>
              <option value="">— Select employee —</option>
              {employees.map(e => (
                <option key={e.id} value={e.id}>
                  {e.name} {e.has_biometric ? '✅' : '⬜'} · {e.department}
                </option>
              ))}
            </select>

            {status === 'error' && message && <div className="alert alert-error" style={{ marginBottom:'1rem' }}>{message}</div>}

            <button className="btn btn-primary btn-block" onClick={handleRegister} disabled={status === 'registering'}
              style={{ fontSize:15, padding:'12px 16px', marginBottom:'1rem' }}>
              {status === 'registering'
                ? <><div className="spinner" />Follow the prompt on your device…</>
                : '🔑 Start biometric registration'}
            </button>

            <div style={{ background:'var(--gray-50)', borderRadius:'var(--radius)', padding:'12px 14px', fontSize:12, color:'var(--gray-500)', lineHeight:1.7 }}>
              <strong style={{ color:'var(--gray-700)' }}>How it works: </strong>
              Your browser opens a system prompt to scan your fingerprint or face. The biometric never leaves your device — only a cryptographic key is saved. Each device needs its own registration.
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const S = { label: { display:'block', fontWeight:500, fontSize:12, color:'var(--gray-700)', textTransform:'uppercase', letterSpacing:'.04em', marginBottom:5 } };
